import type { ContactCenterUserContext as UserContext } from '@ucc/admin-global-state'
import { Permissions } from '@ucc/admin-global-state'

import { AnalyticsUserAccess, IntercomUserAccess } from 'types/UserContext'

export const getIntercomUserAccess = (userContext: UserContext): IntercomUserAccess => ({
  license: userContext.license,
  can_access_agent_portal: userContext.permissions.includes(Permissions.VIEW_AGENT_PAGE),
  can_access_supervisor_portal: userContext.permissions.includes(Permissions.VIEW_SUPERVISOR_PAGE),
  can_access_cc_configuration_portal: userContext.permissions.includes(
    Permissions.VIEW_CONTACT_CENTER_ADMIN_CONFIGURATION_PAGE,
  ),
  can_access_reports_analytics: userContext.permissions.includes(Permissions.VIEW_REPORTING_PAGE),
})

export const getAnalyticsUserAccess = (userContext: UserContext): AnalyticsUserAccess => ({
  license: userContext.license,
  canAccessAgentPortal: userContext.permissions.includes(Permissions.VIEW_AGENT_PAGE),
  canAccessSupervisorPortal: userContext.permissions.includes(Permissions.VIEW_SUPERVISOR_PAGE),
  canAccessCCConfigurationPortal: userContext.permissions.includes(
    Permissions.VIEW_CONTACT_CENTER_ADMIN_CONFIGURATION_PAGE,
  ),
  canAccessReportsAnalytics: userContext.permissions.includes(Permissions.VIEW_REPORTING_PAGE),
})
